<div>

  <tabset #staticTabs [ngClass]="{'d-none': !enable}">
    <tab id="GeneralInfo" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.GeneralInfo'|translate}}">
      <ng-content select=".General"></ng-content>
    </tab>

    @if (fact) {
      <tab id="FactSheet" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.FactSheets'|translate}}" class="fact_tab">
        @if (loadingFactSheets) {
          <app-loading-spinner></app-loading-spinner>
        }
        @for (item of factSheets; track item) {
          <div class="list-group">
            <a href="{{item.fileUrl}}" target="_blank">
              <app-pdf-url-row>
                <h5 style="color: black">{{ item.title }}</h5>
              </app-pdf-url-row>
            </a>
          </div>
        }
      </tab>
    }

    @if (faq) {
      <tab id="Faq" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.FAQ'|translate}}">
        @if (loadingFaq) {
          <app-loading-spinner></app-loading-spinner>
        }
        @for (item of FaqData; track item) {
          <div class="faq_tab">
            <h5 [innerHTML]="item.question | safeHtml"></h5>
            <p [innerHTML]="item.answer | safeHtml"></p>
          </div>
        }
      </tab>
    }

    @if (forms) {
      <tab id="Forms" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.Forms'|translate}}" class="forms_tab">
        @if (loadingForms) {
          <app-loading-spinner></app-loading-spinner>
        }
        <app-form-list [forms]="formDetails"></app-form-list>
      </tab>
    }

    @if (calculators) {
      <tab id="Calculators" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.Calculator'|translate}}">
        <ng-content select=".Calculator"></ng-content>
      </tab>
    }

    @if (videos) {
      <tab id="Videos" (selectTab)="onTabClicked($event)" heading="Videos">
        <ng-content select=".Videos"></ng-content>
      </tab>
    }

    <!-- Unique to Disaster Relief Page --------------------------------->
    @if (notices) {
      <tab heading="Notices to property owners" >
        <ng-content select=".Notices"></ng-content>
      </tab>
    }
    <!-- ----------------------------------------------------------------- -->

    @if (pastEvents) {
      <tab id="PastEvents" (selectTab)="onTabClicked($event)" heading="Past Events">
        <ng-content select=".past"></ng-content>
      </tab>
    }

    @if (news) {
      <tab id="News" (selectTab)="onTabClicked($event)" heading="News">
        <ng-content select=".news"></ng-content>
      </tab>
    }
  </tabset>

  @if (!enable) {
    <div style="width: 100%; position: relative; height: 50vh; z-index: 0; background-color: transparent;"
      class="inner-text">
      <ngx-spinner [fullScreen]="false" color="#fff" bdColor="transparent"
        type="ball-spin-fade-rotating" size="large">
      </ngx-spinner>
    </div>
  }
</div>
